import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
} from 'firebase/firestore'
import { db } from '../../firebase'
import { IconPickerItem } from '../Form/IconField'
import PaginatedTable from '../PaginatedTable'
import Spinner from '../Spinner'

export default function UserTypesList() {
  const navigate = useNavigate()
  const [rows, setRows] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [loading, setLoading] = useState(true)

  const [opts, setOpts] = useState({
    itemsPerPage: 10,
    sortBy: 'id',
    sortOrder: 'asc',
    persistent: true,
    uid: 'user-types-list',
  })

  const columns = [
    {
      name: 'ID',
      sortKey: 'id',
      render: (item) => item.id,
    },
    {
      name: 'Name',
      sortKey: 'name',
      render: (item) => item.name,
    },
    {
      name: 'Icon',
      render: (item) => (
        <IconPickerItem icon={item.icon} size={24} color={item.color} />
      ),
    },
  ]

  useEffect(() => {
    const fetchUserTypes = async () => {
      setLoading(true)
      try {
        const userTypesRef = collection(db, 'userTypes')

        let q = query(
          userTypesRef,
          orderBy(opts.sortBy, opts.sortOrder),
          limit(opts.itemsPerPage)
        )

        if (currentPage > 0) {
          const previousSnapshot = await getDocs(
            query(
              userTypesRef,
              orderBy(opts.sortBy, opts.sortOrder),
              limit(currentPage * opts.itemsPerPage)
            )
          )

          const lastVisible =
            previousSnapshot.docs[previousSnapshot.docs.length - 1]

          q = query(
            userTypesRef,
            orderBy(opts.sortBy, opts.sortOrder),
            startAfter(lastVisible),
            limit(opts.itemsPerPage)
          )
        }

        const snapshot = await getDocs(q)
        const userTypesData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))

        setRows(userTypesData)
        setTotalCount((await getDocs(userTypesRef)).size)
      } catch (err) {
        console.error('Error fetching user types:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchUserTypes()
  }, [currentPage, opts])

  const setPage = (page) => setCurrentPage(page)
  const setOptions = (newOpts) => {
    setOpts((prev) => ({ ...prev, ...newOpts }))
    setCurrentPage(0)
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <div className="box">
      <PaginatedTable
        className="is-fullwidth is-hoverable"
        columns={columns}
        rows={rows}
        currentPage={currentPage}
        totalCount={totalCount}
        loading={loading}
        setPage={setPage}
        opts={opts}
        setOpts={setOptions}
        onRowClick={(item) => navigate(`/system/user-types/${item.id}`)}
      />
    </div>
  )
}
